// import { enableProdMode } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { environment } from './environments/environment';

// if (environment.production) {
//   enableProdMode();
// }

// enableProdMode();
// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));


import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { ErrorInterceptor } from './app/core/helpers/error.interceptor';
import { AuthInterceptor } from './app/core/helpers/auth.interceptor';
import { EventInterceptor } from './app/core/helpers/event.interceptor';
import { PermissionsInterceptor } from './app/core/helpers/permission.interceptor';
import { NotificationInterceptor } from './app/core/helpers/notification.interceptor';

// Enable production mode if in production environment
if (environment.production) {
  // enableProdMode();
}


if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('combined-sw.js')
      .then(reg => {
        // console.log('Service Worker registered manually:', reg);
        return navigator.serviceWorker.ready;
      })
      .then(readyReg => {
        // console.log('Service Worker is ready:', readyReg);
      })
      .catch(err => {
        // console.error('Service Worker registration or readiness failed:', err);
      });
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: EventInterceptor, multi: true }, //Call to handle success realated stuff
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PermissionsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NotificationInterceptor, multi: true },
    ...appConfig.providers
  ]
})
.catch((err) => console.error('Error during bootstrapping the application:', err));

